import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const TransporterAccountInfoComponent = ({ stores, accounts, onInnerFormChange, selectedTransporters }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="PersonAccount"
            name="IsPersonAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsPersonAccount',
                selectedTransporters?.Account
              )
            }}
            type="checkbox"
            value={selectedTransporters?.Account?.IsPersonAccount}
          />
          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.Name',
                selectedTransporters?.Account
              )
            }}
            type="text"
            value={selectedTransporters?.Account?.Name}
          />
          <InputContainer
            label="Number Of Vehicles"
            name="NumberOfVehicles"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.NumberOfVehicles',
                selectedTransporters?.Account
              )
            }}
            type="number"
            value={selectedTransporters?.Account?.NumberOfVehicles}
          />
          <InputContainer
            label="Account"
            labelField="Name"
            list={accounts}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.AccountId',
                selectedTransporters?.Account
              )
            }}
            optionName="Choose Account"
            type="select"
            value={selectedTransporters?.Account?.AccountId}
            valueField="Id"
          />

        </div>
      }
      expandedPanel="accountInfo"
      headerTitle="Account Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="RAPVerified"
            name="IsRAPVerified"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'RAPInfo.IsRAPVerified',
                selectedTransporters?.RAPInfo
              )
            }}
            type="checkbox"
            value={selectedTransporters?.RAPInfo?.IsRAPVerified}
          />

          <InputContainer
            label="Store"
            labelField="StoreName"
            list={stores}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'RAPInfo.PrimaryStoreId',
                selectedTransporters?.RAPInfo
              )
            }}
            optionName="Choose Store"
            type="select"
            value={selectedTransporters?.RAPInfo?.PrimaryStoreId}
            valueField="Id"
          />
          <InputContainer
            label="Remarks"
            name="Remarks"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'RAPInfo.Remarks',
                selectedTransporters?.RAPInfo
              )
            }}
            type="text"
            value={selectedTransporters?.RAPInfo?.Remarks}
          />

        </div>
      }
      expandedPanel="OperatorInfo"
      headerTitle="Operator Info"
    />
  </>
)
export default TransporterAccountInfoComponent;
